<div class="container-fluid d-flex justify-content-center">
  <div class="credit-container">

    <form [formGroup]="creditReport" novalidate>

      <!-- Centered ID input + button -->
      <div class="row justify-content-center">

        <div class="col-3">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>South African ID Number</mat-label>
            <input
              
              matInput
              type="text"
              maxlength="13"
              formControlName="idNumber"
              placeholder="Enter ID Number"
            />
            <mat-error *ngIf="creditReport.get('idNumber')?.invalid && creditReport.get('idNumber')?.touched">
              ID number must be 13 digits.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-3 ">
          <button
            mat-raised-button
            color="primary"
            class="generate-btn"
            (click)="generateCreditReport()"
            [disabled]="loading || creditReport.invalid"
          >
            {{ loading ? 'Generating...' : 'Generate Credit Report' }}
          </button>
        </div>

      </div>
      <div *ngIf="creditReportReceived" class="row row-padding">
          <br>
          <button mat-fab class="form-button-right" style="box-shadow: none;" type="submit" (click)="goToClientDetails()" [disabled]="!creditReport.valid && creditReportReceived"><i class="fa fa-arrow-right" ></i></button>
      </div>
    </form>

    <!-- PDF PREVIEW SECTION -->
    <div *ngIf="pdf" >
      <h4>Credit Report</h4>
      <embed
        [src]="pdf"
        type="application/pdf"
        width="100%"
        height="400px"
      />
    </div>
    
      <div *ngIf="creditReportReceived" class="d-flex justify-content-center">
          <br>
          <button mat-fab class="generate-btn" style="box-shadow: none; width: 20%; height: 50px;" type="submit" (click)="downloadPdf()">Download Credit Report</button>
      </div>

  </div>
</div>
